import {
    CollisionEventType,
    Component,
    MeshComponent,
    Object3D,
    PhysXComponent,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

export class HeadBlock extends Component {
    static TypeName = 'head-block';

    @property.int(2)
    blockMask = 2;

    @property.object({required: true})
    fadeSphere!: Object3D;

    private headBlock?: PhysXComponent;
    private textFade?: MeshComponent;

    start() {
        const headBlockTemp = this.object.getComponent(PhysXComponent);
        if (!headBlockTemp) {
            throw new Error(
                `HeadBlock(${this.object.name}) does not have a PhysX component`
            );
        }
        this.headBlock = headBlockTemp;
        this.headBlock.onCollision(this.onCollisionHandler);

        this.textFade = this.fadeSphere.getComponent(MeshComponent)!;
        this.textFade.active = false;
    }

    onCollisionHandler = (type: CollisionEventType, other: PhysXComponent) => {
        if ((other.groupsMask | (1 << 2)) !== 0) {
            if (type === CollisionEventType.Touch) {
                console.log('HeadBlock: Touch');
                this.textFade!.active = true;
            } else if (type === CollisionEventType.TouchLost) {
                console.log('HeadBlock: TouchLost');
                this.textFade!.active = false;
            }
        }
    };
}
